import CheckoutSection from '../components/CheckoutSection';

export default function CheckoutPage() {
  return (
    <>
      <CheckoutSection />
    </>
  );
}
